<template>
  <wapi-panel :title="''">
    <template v-slot:content>
      <div style="height: 415px;">
        <l-map :zoom="13" :center="center" ref="map" :class="'wapi_map__map'">
          <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
          <l-marker :lat-lng="latLng"></l-marker>
        </l-map>
      </div>
    </template>
  </wapi-panel>
</template>

<script>
import WapiPanel from "../components/WapiPanel";

export default {
  name: "BillingPoint",
  components: {
    WapiPanel
  },
  props: {
    model: Array,
    geoJson: Object,
    markerLatLng: Array
  },
  computed: {
    center() {
      return this.latLng;
    },
    latLng() {
      if (this.markerLatLng.length) {
        return [this.markerLatLng[1], this.markerLatLng[0]];
      }

      return [];
    }
  }
};
</script>